import React from 'react';
import { motion } from 'framer-motion';
interface SectionHeadingProps {
  title: string;
  subtitle?: string;
  align?: 'left' | 'center';
  className?: string;
}
export function SectionHeading({
  title,
  subtitle,
  align = 'left',
  className = ''
}: SectionHeadingProps) {
  return <div className={`mb-12 ${align === 'center' ? 'text-center' : 'text-left'} ${className}`} data-id="element-253">
      <motion.h2 initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} className="text-3xl md:text-4xl font-bold text-white mb-4 tracking-tight" data-id="element-254">
        {title}
      </motion.h2>
      {subtitle && <motion.p initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      delay: 0.1
    }} className="text-lg text-gray-400 max-w-3xl mx-auto leading-relaxed" data-id="element-255">
          {subtitle}
        </motion.p>}
      <div className={`mt-6 h-1 w-20 bg-cyan-500 rounded-full ${align === 'center' ? 'mx-auto' : ''}`} data-id="element-256" />
    </div>;
}